module.exports = __webpack_public_path__ + "da2900301a8153ff055836ea2026f9f2.MP3";